import styled from 'styled-components';
import { Icon, Typography } from '../../../../../stories/atoms';

export const StyledTypography = styled(Typography)`
  flex: 1;
  align-content: space-around;
`;

export const StyledIcon = styled(Icon)`
  width: ${({ theme: { spacing } }) => spacing(6)};
  height: ${({ theme: { spacing } }) => spacing(6)};
  padding: ${({ theme: { spacing } }) => spacing(1)};
  margin: ${({ theme: { spacing } }) => spacing(0, 1, 0, 0)};
`;
